import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showSocialProof?: boolean;
}
export function App({
  showSocialProof = true
}: AppProps) {
  useMetaPixel();
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-green/20" data-id="element-0" data-mp="3rd1azm9kzjpm">
      <main data-id="element-1" data-mp="82k72sfnuax">
        <HeroSection onCtaClick={scrollToPricing} data-id="element-2" data-mp="7sxpp6lk59z" />
        <StatsBar data-id="element-3" data-mp="2zmeowbge3q93" />
        <TransformationSection data-id="element-4" data-mp="2zmwit1fkxsdu" />
        <PainPointsSection data-id="element-5" data-mp="33mowfsjtyoq2" />
        <KitContentsSection data-id="element-6" data-mp="33lx0ggmbmoz9" />
        <InstantAccessSection data-id="element-7" data-mp="33n6wl09m5n39" />
        <BonusesSection data-id="element-8" data-mp="38lrp0dimj2h5" />
        <PricingSection data-id="element-9" data-mp="38l8eviz7tido" />
        <GuaranteeSection data-id="element-10" data-mp="38l05i12awv78" />
        <TestimonialsSection data-id="element-11" data-mp="38nuqbtp88i16" />
        <AboutSection data-id="element-12" data-mp="3dkl60fx4dbm2" />
        <FAQSection data-id="element-13" data-mp="3dlw6o6v9q38y" />
        <FinalCTASection onCtaClick={scrollToPricing} data-id="element-14" data-mp="3dmfolnkx4rmz" />
      </main>
      <Footer data-id="element-15" data-mp="nwc2vvuco1xu" />
      {showSocialProof && <SocialProofPopup data-id="element-16" data-mp="nvaqno1ll9ej" />}
    </div>;
}